import Hero from './components/Hero';
import Introduction from './components/Introduction';
import NotPlatform from './components/NotPlatform';
import Services from './components/Services';
import QuoteSection from './components/QuoteSection';
import Reviews from './components/Reviews';
import Gallery from './components/Gallery';
import FinalCTA from './components/FinalCTA';
import Footer from '../../components/feature/Footer';
import StickyQuoteBar from './components/StickyQuoteBar';
import MobileBottomBar from './components/MobileBottomBar';
import SeoJsonLd from './components/SeoJsonLd';

export default function HomePage() {
  return (
    <div>
      <SeoJsonLd />
      <div className="min-h-screen bg-white pb-[72px] md:pb-24">
        <Hero />
        <Introduction />
        <NotPlatform />
        <Services />
        <QuoteSection />
        <Reviews />
        <Gallery />
        <FinalCTA />
        <Footer />
      </div>
      <StickyQuoteBar />
      <MobileBottomBar />
    </div>
  );
}